import PropTypes from 'prop-types';
import React from 'react';
import { convertStringToLowercase } from '../../../../../utils/convertValues';
import { MoreListItem } from '../../../../lists/items/header';
/**
 * @description Render memoized more content dropdown component
 * @param {Array} menu
 * @param {Function} onExpandedMenuMouseEnter
 * @returns {JSX.Element} Memoized more content dropdown component
 */
export const MoreContentDropdown = ({ menu }) => {
  if (!menu) {
    return null;
  }

  return (
    <div className="primary-navigation__list">
      <ul className="primary-navigation__list--count-3">
        {menu
          .filter(
            (item) =>
              convertStringToLowercase(item?.contentLink?.expanded?.name) !== 'beds' &&
              convertStringToLowercase(item?.contentLink?.expanded?.name) !== 'furniture' &&
              convertStringToLowercase(item?.contentLink?.expanded?.name) !== 'bedding'
          )
          .map((item, index) => (
            <MoreListItem key={item?.contentLink?.expanded?.page?.id || index} item={item} />
          ))}
      </ul>
    </div>
  );
};

MoreContentDropdown.propTypes = {
  menu: PropTypes.array
};
